import { PropretyAttributes } from "../../decorators/EntityDecorators";

export class AdminTenantInfoDTO {

  @PropretyAttributes({
    maxLength: 50,
    minLength: 3,
    pattern: "^[\\s\\S]*$",
  })
  FullName!: string;

  @PropretyAttributes({
    maxLength: 50,
    minLength: 3,
    pattern: "^[\\s\\S]*$",
  })
  Email!: string;

  @PropretyAttributes({
    maxLength: 50,
    minLength: 3,
    pattern: "^[\\s\\S]*$",
  })
  PhoneNumber?: string;

  TwoFactorEnabled: boolean = false;

  @PropretyAttributes({
    maxLength: 50,
    minLength: 3,
    pattern: "^[\\s\\S]*$",
  })
  Password!: string;

  @PropretyAttributes({
    maxLength: 50,
    minLength: 3,
    pattern: "^[\\s\\S]*$",
  })
  ConfirmPassword!: string
}